import { CollectionCard, type CollectionCardEntity } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

const collection: CollectionCardEntity = {
  id: "1",
  name: "Foundations of Machine Learning",
  description:
    "A curated path through the core ideas — linear models, loss landscapes, and the bias-variance tradeoff — with hands-on quick checks along the way.",
  studioName: "Math Studio",
  itemCount: 7,
  visibility: "public",
  items: [
    { id: "a", title: "Linear models" },
    { id: "b", title: "Loss landscapes" },
    { id: "c", title: "Bias & variance" },
  ],
};

export function CollectionCardDemo() {
  return (
    <Section
      id="collection-card"
      title="CollectionCard"
      description="Collection tile for AI Studio. Composes the brand Card, so it inherits the Onyx hex-notch silhouette (nx-s), the clip-safe .elev-card drop-shadow, and the continuous nx-rim keyline ring — no border or box-shadow of its own (#158). The cover area renders an animated Folder whose papers fan out on click; grid view stays overflow-visible so the papers can escape the cover while the notch clip still shapes the card."
    >
      <VariantBlock label="Explore" caption='mode="explore" — folder cover, Open CTA, AIKO hover hint on the title'>
        <div className="w-[340px]">
          <CollectionCard collection={collection} mode="explore" onView={() => {}} />
        </div>
      </VariantBlock>

      <VariantBlock label="Manage" caption='mode="manage" — Edit primary + a notched dropdown for View / Delete'>
        <div className="w-[340px]">
          <CollectionCard
            collection={collection}
            mode="manage"
            onView={() => {}}
            onEdit={() => {}}
            onDelete={() => {}}
          />
        </div>
      </VariantBlock>

      <VariantBlock label="List view" caption='view="list" — 2x2 mosaic thumbnail, same nx-s surface in a tight row'>
        <div className="w-[520px] max-w-full">
          <CollectionCard collection={collection} view="list" mode="explore" onView={() => {}} />
        </div>
      </VariantBlock>

      <VariantBlock label="Skeleton" caption="CollectionCard.Skeleton — hand-rolled but on the same notch + elev + rim recipe">
        <div className="w-[340px]">
          <CollectionCard.Skeleton />
        </div>
      </VariantBlock>
    </Section>
  );
}
